export default __webpack_public_path__ + "static/media/sheba-form.fa065351.JPG";